import { Decimal } from "decimal.js";

Decimal.set({
  precision: 20,
});

export { Decimal };
